/**
 * Modal Alpine Component
 * Global modal manager with event-based triggering
 *
 * Trigger from anywhere:
 * $dispatch('modal:open', { id: 'my-modal', size: 'lg' })
 * $dispatch('modal:close')
 *
 * Sizes: 'sm' | 'md' | 'lg' | 'full'
 */
export default function Modal() {
  return {
    isOpen: false,
    activeModal: null,
    size: 'md',
    previousFocus: null,

    init() {
      window.addEventListener('modal:open', (e) => this.open(e.detail));
      window.addEventListener('modal:close', () => this.close());
    },

    open(options = {}) {
      this.previousFocus = document.activeElement;
      this.activeModal = options.id || null;
      this.size = options.size || 'md';
      this.isOpen = true;
      document.body.classList.add('overflow-hidden');

      this.$nextTick(() => {
        const focusable = this.$refs.panel?.querySelector(
          'input, select, textarea, button:not([aria-label="Close modal"]), a[href], [tabindex]:not([tabindex="-1"])',
        );
        focusable?.focus();
      });
    },

    close() {
      this.isOpen = false;
      document.body.classList.remove('overflow-hidden');
      this.previousFocus?.focus();
      setTimeout(() => {
        this.activeModal = null;
      }, 200);
    },

    isActive(id) {
      return this.activeModal === id;
    },

    get sizeClass() {
      const sizes = {
        sm: 'max-w-md',
        md: 'max-w-2xl',
        lg: 'max-w-5xl',
        full: 'max-w-full mx-4',
      };
      return sizes[this.size] || sizes.md;
    },
  };
}
